<div class="orders-stocks">
	<div class="filter">
		@if (widget()?.assetClass) {
			<app-asset-type [widget]="widget()" />
		}

		<div class="tabs">
			@for (state of ordersStatesTables; track state) {
				<app-button
					[appearance]="activeOrderTable() === state ? 'dark' : 'flat'"
					size="s"
					(clicked)="setOrderState(state)"
				>
					{{ 'orders.activeOrders.' + state | translate }}
				</app-button>
			}
		</div>
	</div>

	<div class="table">
		@switch (activeOrderTable()) {
			@case (orderStateEnum.OPEN) {
				<app-opened-orders [widget]="widget()" />
			}
			@case (orderStateEnum.CANCELED) {
				<app-canceled-orders [widget]="widget()" />
			}
			@case (orderStateEnum.FILLED) {
				<app-filled-orders [widget]="widget()" />
			}
		}
	</div>
</div>
